// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_3v-1";
export var movingGradient = "_3v-4";
export var movingGradientBlock = "_3v-2";
export var skeleton = "_3v-0";
export var skeletonText = "_3v-3";